import moment from "moment";
import * as XLSX from "xlsx";

import { COLUMNAS_GESTION } from "../model/gestion";

// "Materia: " -> "Materia". Sin nombre, el encabezado es el id, como hace
// ListarDatos con su Excel.
const encabezado = ({ nombre, id }) => (nombre || id).replace(/:\s*$/, "");

/**
 * Descarga un Excel con las solicitudes, con las mismas columnas del
 * listado. El listado trae solo una pagina, por eso el Excel se arma con
 * todas las que manda el servidor aparte (?exportar=1).
 */
export const descargarExcel = (solicitudes, nombre) => {
  const filas = solicitudes.map((solicitud) =>
    COLUMNAS_GESTION.reduce(
      (fila, columna) => ({ ...fila, [encabezado(columna)]: columna.mostrar(solicitud) }),
      {},
    ),
  );

  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, XLSX.utils.json_to_sheet(filas), "Solicitudes");
  XLSX.writeFile(libro, `${nombre}-${moment().format("YYYY-MM-DD HH.mm")}.xlsx`);
};
